import {
  ManageAwardResponse,
  ManageAwardRow,
  ManageScore,
  ManageScoreResponse,
  ParameterType,
  ParameterTypeResponse,
  TargetResponse,
  TargetRow,
} from "../types/configuration";

const configurationParser: any = {};

configurationParser.parameterType = (
  res: ParameterTypeResponse
): ParameterType[] => {
  return res.data.map((pra) => ({
    parameterTypeId: pra.parameterTypeId,
    parameterTypeName: pra.parameterTypeName,
    percentage: pra.percentage,
    parametePercentageId: pra.ParameterPercentageId,
  }));
};
configurationParser.manageScore = (res: ManageScoreResponse) => {};

configurationParser.getManageAwardParser = (response: ManageAwardResponse) => {
  let data: ManageAwardRow[] = [];

  if (
    response.success &&
    typeof response.data === "object" &&
    response.data !== null &&
    Array.isArray(response.data.rows) &&
    response.data.rows.length > 0
  ) {
    data = response.data.rows;
  }
  let total = response?.data?.rowCount;

  const tableRowData = data?.map((row: ManageAwardRow) => ({
    manageAwardId: row.manageAwardId,
    awardName: row.awardName,
    point: row.point,
    operator: row.operator,
    leadCount: row.leadCount,
    programMasterId: row.programMasterId,
    programYearId: row.programYearId,
    quarterMasterId: row.quarterMasterId,
    isActive: row.isActive,
    createdAt: new Date(row.createdAt),
    updatedAt: new Date(row.updatedAt),
    publishedAt: new Date(row.publishedAt),
  }));

  return {
    totalRowCount: total,
    tableRowData,
  };
};

configurationParser.getTargetParser = (response: any) => {
  if (
    !response ||
    typeof response !== "object" ||
    !response?.data.targets ||
    !Array.isArray(response?.data?.targets)
  ) {
    console.error("Invalid response structure:", response);
    return [];
  }

  const targets = response?.data?.targets
    .map((center: any, index: number) => {
      if (
        !center?.centerId ||
        !center?.centerName ||
        !Array.isArray(center?.targetScores)
      ) {
        console.warn("Invalid center data:", center);
        return null;
      }

      return {
        id: index,
        centerId: center?.centerId,
        centerName: center?.centerName,
        targetDuration: center?.targetDuration,
        targetId: center?.targetId,
        bonusPoints: center?.bonusPoints,
        malPractice: center?.malPractice,
        targetScores: center?.targetScores
          .map((target: any) => {
            if (
              !target?.targetParameterId ||
              !target?.targetParameterName ||
              typeof target?.score !== "number"
            ) {
              console.warn("Invalid target data:", target);
              return null;
            }

            return {
              targetParameterId: target?.targetParameterId,
              targetParameterName: target?.targetParameterName,
              score: target?.score,
              scoreAchived: target?.scoreAchived,
            };
          })
          .filter(Boolean),
      };
    })
    .filter(Boolean);

  return {
    targets,
    totalCount: response?.data?.totalCount,
  };
};

configurationParser.getManageAwardParser = (response: ManageAwardResponse) => {
  let data: ManageAwardRow[] = [];

  if (
    response.success &&
    typeof response.data === "object" &&
    response.data !== null &&
    Array.isArray(response.data.rows) &&
    response.data.rows.length > 0
  ) {
    data = response.data.rows;
  }
  let total = response?.data?.rowCount;

  const tableRowData = data?.map((row: ManageAwardRow) => ({
    manageAwardId: row.manageAwardId,
    awardName: row.awardName,
    point: row.point,
    operator: row.operator,
    leadCount: row.leadCount,
    programMasterId: row.programMasterId,
    programYearId: row.programYearId,
    quarterMasterId: row.quarterMasterId,
    isActive: row.isActive,
    createdAt: new Date(row.createdAt),
    updatedAt: new Date(row.updatedAt),
    publishedAt: new Date(row.publishedAt),
  }));

  return {
    totalRowCount: total,
    tableRowData,
  };
};

// ... existing code ...
configurationParser.manageScoreParser = (response: ManageScoreResponse) => {
  let data: any = [];

  if (
    response.success &&
    response.data !== null &&
    Array.isArray(response.data) &&
    response.data.length > 0
  ) {
    data = response.data;
  }

  let total = response?.data?.rawsCount;

  const tableRowData = data
    ?.map((element: any) => {
      return element.parameterData.map((parameterData: any) => ({
        categories: parameterData?.categories,
        targetParameters: parameterData?.targetParameters?.map(
          (target: any) => ({
            targetParameterId: target?.targetParameterId,
            parameterName: target?.parameterName,
            weightages: target?.weightages?.map((weight: any) => ({
              weightageId: weight?.weightageId,
              weightage: weight?.weightage,
              subWeightages: weight?.subWeightages?.map((subWeight: any) => ({
                subWeightage: subWeight?.subWeightage,
                measurementCriteria: subWeight?.measurementCriteria?.map(
                  (criteria: any) => ({
                    measurementCriteriaId: criteria?.measurementCriteriaId,
                    region: criteria?.region,
                    operator: criteria?.operator,
                    measurementCriteria: criteria?.measurementCriteria,
                    highestScoreCanBeObtained:
                      criteria?.highestScoreCanBeObtained,
                    score: criteria?.score,
                    metadata: criteria?.metadata,
                    manageScoreId: criteria?.manageScoreId,
                  })
                ),
              })),
            })),
          })
        ),
      }));
    })
    .flat(2);

  return tableRowData;
};
// ... existing code ...

// configurationParser.targetParameterParser = (data: any) => {
//   if (!data || !data.data) {
//     console.error("Invalid Data Format");
//     return;
//   }

//   // Resulting parsed structure
//   const parsedData: { id: number; name: string; parameters: any[] }[] = [];

//   // Iterate through each parameterType
//   data?.data?.forEach((parameterType: any) => {
//     const { parameterTypeId, parameterTypeName, targetParameters } =
//       parameterType;

//     if (!parameterTypeId || !parameterTypeName || !targetParameters) {
//       console.warn("Incomplete Parameter Type Data:", parameterType);
//       return;
//     }

//     // Build the structure for each parameter type
//     parsedData?.push({
//       id: parameterTypeId,
//       name: parameterTypeName,
//       parameters:
//         targetParameters?.map((param: any) => ({
//           id: param?.targetParameterId,
//           name: param?.parameterName,
//           categories: param?.categories,
//         })) || [],
//     });
//   });

//   return parsedData;
// };
configurationParser.targetParameterParser = (data: any) => {
  if (!data || !data.success || !Array.isArray(data.data)) {
    throw new Error("Invalid data format");
  }

  const result: any = {};

  data?.data?.forEach((parameterType: any) => {
    const { parameterTypeId, parameterTypeName, categories }: any =
      parameterType;

    if (!parameterTypeId || !parameterTypeName || !categories) {
      return;
    }

    result[parameterTypeName] = {};

    Object.entries(categories)?.forEach(([categoryName, parameters]) => {
      if (!Array.isArray(parameters)) {
        return;
      }

      result[parameterTypeName][categoryName] = parameters?.map(
        (param: any) => {
          return {
            id: param?.targetParameterId,
            name: param?.parameterName,
          };
        }
      );
    });
  });
  return result;
};
export default configurationParser;
